import React from 'react'
import { Image } from 'react-bootstrap'
import * as s from './EnterPicksRecentGame.scss'
import { nflTeamImage } from '@severed-links/common.redherrings-constants'

const EnterPicksRecentGame = ({ game = {}, index = -1 }) => {

    return (
        <div className={s.container} key={index}>
            <span className={s.recentGameTime}>{game.dateDisplay}</span>
            <div className={s.recentGameTeamContainer}>
                <div className={s.recentGameTeam}>
                    <Image alt={`${game.visitorMascot} (away)`} src={nflTeamImage(game.visitorMascot)} className={s.teamImage} />
                    <div className={s.recentGameScore}>{game.visitorScore}</div>
                </div>
                <div className={s.recentGameTeam}>
                    <Image alt={`${game.homeMascot} (home)`} src={nflTeamImage(game.homeMascot)} className={s.teamImage} />
                    <div className={s.recentGameScore}>{game.homeScore}</div>
                </div>
            </div>
        </div>
    )
}
    
export default EnterPicksRecentGame